/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{s}from"../../../../chunks/vec4.js";import{Z as n,c}from"../../../../chunks/vec4f64.js";function o(c){return null==c?n:4===c.length?c:s(r,c[0],c[1],c[2],1)}const r=c();export{o as ensureColor4};
